fragment VideoFeatureFragment on videoFeature_Entry {
  typeHandle
}
